import React from "react";
import { Row } from "react-bootstrap";

import { myUtilities } from "../../Utils";
import { globalVars } from "../../App";

const tnCWireFrame = (
  invData,
  agreementType,
  reference,
  agreementPath,
  showTAndCHtml
) => {
  return (
    <Row>
      <div className="terms-and-conditions">
        <div>
          <form action="javascript:void(0);" id="terms-and-conditions-form">
            <div id="checkboxTnc" class="checkboxOne">
              <input
                ref={reference}
                title={showValidationMessage()}
                onInvalid={() =>
                  reference.current.setCustomValidity(
                    myUtilities.accountSpecificLanguage(
                      "form.validation.error",
                      "Please fill out this field."
                    )
                  )
                }
                type="checkbox"
                required
                id="myGlitchedCheckbox"
                onChange={() =>
                  (globalVars.isTermsSelected = !globalVars.isTermsSelected)
                }
              />
              <label for="myGlitchedCheckbox"></label>
            </div>
          </form>
          <label className="payment-tnc-label">
            {myUtilities.accountSpecificLanguage(
              "Terms.IAccept",
              "I accept the"
            )}
            <a
              href
              onClick={() =>
                getOnClickOnTncType(
                  agreementType,
                  invData,
                  agreementPath,
                  showTAndCHtml
                )
              }
            >
              {myUtilities.accountSpecificLanguage(
                "Terms.TermsAndConditions",
                "Terms and Conditions"
              )}
            </a>
          </label>
          <br />
        </div>
      </div>
    </Row>
  );
};

const showValidationMessage = () =>
  globalVars.isTermsSelected
    ? ""
    : myUtilities.accountSpecificLanguage(
        "form.validation.error",
        "Please fill out this field."
      );

const getOnClickOnTncType = (
  typeOfAgreement,
  invData,
  agreementPath,
  showTAndCHtml
) => {
  switch (typeOfAgreement) {
    case "staticLink":
      window.open(agreementPath, "_blank");
      break;
    case "html":
      showTAndCHtml();
      break;
    case "s3Path":
      let token = invData.state.token
        ? invData.state.token
        : window.location.search.substring(7, window.location.search.length);
      let fileName =
        "/radiusoneweb/securedFileDownload?file=" +
        agreementPath.trim() +
        "&token=" +
        encodeURIComponent(token) +
        "&src=TC";
      window.open(fileName);
      break;
    default:
      break;
  }
};

const TncBox = ({ payMethod, invData, showTAndCHtml, reference }) => {
  let agreementType =
    payMethod === "DC"
      ? invData.state.dcAgreementType
      : invData.state.ccAgreementType;
  let agreementPath =
    payMethod === "DC"
      ? invData.state.DCAgreementpath
      : invData.state.CCAgreementpath;
  if (
    agreementType === "staticLink" ||
    agreementType === "html" ||
    agreementType === "s3Path"
  )
    return tnCWireFrame(
      invData,
      agreementType,
      reference,
      agreementPath,
      showTAndCHtml
    );
  else {
    return (
      <Row>
        <div className="terms-and-conditions" />
      </Row>
    );
  }
};

export default TncBox;
